module.exports = __webpack_public_path__ + "img/ideum_portrait_2019-01-25.2841076c.jpg";